<template>

    <div class="notice" :class="classes">

        <div v-if="$slots['header']" class="notice-header">
            <slot name="header"></slot>
        </div>

        <div v-if="$slots['body']" class="notice-body">
            <slot name="body"></slot>
        </div>
        <div v-else class="notice-body">
            <h4 class="notice-title" v-if="title" v-html="title" />
            <p class="notice-text" v-if="message" v-html="message" />
        </div>

        <div v-if="$slots['footer']" class="notice-footer">
            <slot name="footer"></slot>
        </div>

    </div>

</template>

<style scoped lang="scss">

    .notice {
        background: #fff;
        border: 1px solid $color-rule;
        color: $color-text;
        text-align: center;
        width: 100%;
        .notice-header,
        .notice-body,
        .notice-footer {
            align-items: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            > *:last-child {
                margin-bottom: 0;
            }
        }
        h4, .notice-title {
            @include font-semibold(22px);
            color: $color-text;
            line-height: 1.4em;
            max-width: 600px;
        }
        p, .notice-text {
            @include font-medium(15px);
            color: $color-text;
            line-height: 1.6em;
            max-width: 600px;
        }
    }

    .notice-sm {
        border-radius: 3px;
        padding: 30px;
        h4, .notice-title {
            font-size: 18px;
            margin: 0 auto 10px auto;
        }
        p, .notice-text {
            font-size: 13px;
            margin: 0 auto 10px auto;
        }
        .notice-header {
            margin-bottom: 20px;
        }
        .notice-footer {
            margin-top: 20px;
        }
    }

    .notice-lg {
        border-radius: 5px;
        padding: 80px 30px;
        h4, .notice-title {
            font-size: 22px;
            margin: 0 auto 15px auto;
        }
        p, .notice-text {
            font-size: 15px;
            margin: 0 auto 10px auto;
        }
        .notice-header {
            margin-bottom: 30px;
        }
        .notice-footer {
            margin-top: 30px;
        }
    }

    .notice-danger {
        border-color: $color-danger;
        h4, .notice-title,
        p, .notice-text {
            color: $color-danger;
        }
    }

    .notice-success {
        border-color: $color-success;
        h4, .notice-title,
        p, .notice-text {
            color: $color-success;
        }
    }

</style>

<script>

export default {

    props: {
        title: {
            type: String,
        },
        message: {
            type: String,
        },
        size: {
            type: String,
            default: 'lg',
        },
        type: {
            type: String,
        },
    },

    computed: {

        classes() {
            return {
                'notice-sm': this.size === 'sm',
                'notice-lg': this.size === 'lg',
                'notice-danger': this.type === 'danger',
                'notice-success': this.type === 'success',
                'notice-trans': this.type === 'trans',
            }
        },

    },

}

</script>
